import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const appKey = process.env.REACT_APP_REVERB_APP_KEY;

const echo = appKey
  ? new Echo({
      broadcaster: 'reverb',
      key: appKey,
      wsHost: process.env.REACT_APP_REVERB_HOST,
      wsPort: process.env.REACT_APP_REVERB_PORT,
      wssPort: process.env.REACT_APP_REVERB_PORT,
      forceTLS: process.env.REACT_APP_REVERB_SCHEME === 'https',
      enabledTransports: ['ws', 'wss'],
      authEndpoint: `${process.env.REACT_APP_BASE_URL}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`,
        },
      },
    })
  : null;

export default echo;